import { Alert } from "antd";
import { ErrorsList } from "./ErrorsList";

type ValidationErrorsProps = {
  data: any;
};

export const ValidationErrors = ({ data }: ValidationErrorsProps) => {
  return (
    <Alert
      type="error"
      className="align-start mb-8 validation-errors"
      showIcon
      message={<ErrorsList data={data} />}
    />
  );
};
